import React from 'react';
import { Link } from 'react-router-dom';
import { Reveal, Stagger, StaggerItem } from './LandingMotion';

export const MarketingFooter = () => {
  return (
    <footer className="bg-white border-t border-black/10 pt-20 pb-12 relative z-10">
      <div className="max-w-[1120px] mx-auto px-6">
        <Stagger className="grid grid-cols-2 md:grid-cols-4 gap-12 mb-16" stagger={0.1} delayChildren={0.05}>
          <StaggerItem className="col-span-2">
            <Link to="/" className="inline-flex items-center mb-6">
              <img
                src="/vh-intelligence-ink.png"
                alt="VH Intelligence"
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-slate-600 max-w-sm leading-relaxed text-sm">
              The standard for construction safety intelligence. Connecting the field to the boardroom with real-time risk data.
            </p>
          </StaggerItem>

          <StaggerItem>
            <h4 className="text-[#1C1C1E] font-semibold mb-6">Platform</h4>
            <ul className="space-y-4 text-sm text-slate-600">
              <li><Link to="/command-center" className="hover:text-orange-400 transition-colors">Command Center</Link></li>
              <li><Link to="/mobile" className="hover:text-orange-400 transition-colors">Mobile App</Link></li>
              <li><Link to="/integrations" className="hover:text-orange-400 transition-colors">Integrations</Link></li>
            </ul>
          </StaggerItem>

          <StaggerItem>
            <h4 className="text-[#1C1C1E] font-semibold mb-6">Company</h4>
            <ul className="space-y-4 text-sm text-slate-600">
              <li><Link to="/about" className="hover:text-orange-400 transition-colors">About Us</Link></li>
              <li><Link to="/careers" className="hover:text-orange-400 transition-colors">Careers</Link></li>
              <li><Link to="/blog" className="hover:text-orange-400 transition-colors">Blog</Link></li>
              <li><Link to="/press" className="hover:text-orange-400 transition-colors">Press</Link></li>
            </ul>
          </StaggerItem>
        </Stagger>

        <Reveal y={16} duration={0.6} className="pt-8 border-t border-black/[0.06] flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-600">
          <p>Copyright © {new Date().getFullYear()} Virtual Hardhat Inc. All rights reserved.</p>
          <div className="flex gap-6">
             <Link to="/privacy" className="hover:text-slate-600 transition-colors">Privacy</Link>
             <Link to="/terms" className="hover:text-slate-600 transition-colors">Terms</Link>
          </div>
        </Reveal>
      </div>
    </footer>
  );
};

